export default __webpack_public_path__ + "static/1311-cf7a3991022610c7964b093c70ede36a.gif";